import merge from 'lodash/merge'

export const ENV = process.env.NEXT_PUBLIC_ENV

const config = {
  default: {
    app: {
      url: 'http://localhost:3002',
    },
    api: {
      auth: 'https://auth-staging.neat.com',
      interrogator: 'https://interrogator-staging.neat.com/graphql',
      gatekeeper: 'https://gatekeeper-staging.neat.com',
    },
    clients: {
      recurly: 'ewr1-jUsi8exmOff3fntJ2rpLMo',
      jawn: 'http://localhost:3003',
    },
  },

  test: {},

  development: {
    api: {
      interrogator: 'https://interrogator-staging.neat.com/graphql',
    },
  },

  staging: {
    app: {
      url: 'https://myaccount-staging.neat.com',
    },
    api: {
      auth: 'https://auth-staging.neat.com',
      interrogator: 'https://interrogator-staging.neat.com/graphql',
      gatekeeper: 'https://gatekeeper-staging.neat.com',
    },
    clients: {
      recurly: 'ewr1-jUsi8exmOff3fntJ2rpLMo',
      jawn: 'https://app-staging.neat.com',
    },
  },

  qa: {
    app: {
      url: 'https://myaccount-qa.neat.com',
    },
    api: {
      auth: 'https://auth-qa.neat.com',
      interrogator: 'https://interrogator-qa.neat.com/graphql',
      gatekeeper: 'https://gatekeeper-qa.neat.com',
    },
    clients: {
      recurly: 'ewr1-C892qOUmwfN2XU9RSuigoe',
      jawn: 'https://app-qa.neat.com',
    },
  },

  production: {
    app: {
      url: 'https://myaccount.neat.com',
    },
    api: {
      auth: 'https://auth.neat.com',
      interrogator: 'https://interrogator.neat.com/graphql',
      gatekeeper: 'https://gatekeeper.neat.com',
    },
    clients: {
      recurly: 'ewr1-kN2T3jHWviU3IAPWWYUuqa',
      jawn: 'https://app.neat.com',
    },
  },
}

export default merge(
  {},
  config.default,
  config[ENV],
)
